/**
 * O `PATCH /{id}/status` devolve `OportunidadeResponse`, que NÃO traz
 * `ultimaMovimentacaoEm` (é campo do resumo da listagem). Ao aplicar a resposta no card
 * recém-movido, o campo antigo sobreviveria ao spread e o card diria "há 3 dias" logo
 * depois de mudar de coluna. A transição acabou de acontecer: o instante da resposta é a
 * última movimentação até a próxima leitura da listagem (que traz o valor do servidor).
 */
export const comMovimentacaoAgora = <T extends object>(
  atualizada: T,
  agora: Date = new Date(),
): T & { ultimaMovimentacaoEm: string } => ({
  ...atualizada,
  ultimaMovimentacaoEm: agora.toISOString(),
})
